import { Injectable } from '@angular/core';
import { ApiService } from '../../common/api.service';
import { Observable } from 'rxjs';
import { ROUTES } from '../../server-route';

@Injectable({
  providedIn: 'root',
})
export class DistrictListService extends ApiService {
  public getDistrictList(statename: any): Observable<any> {
    return this.get<any>(ROUTES.DISTRICT_LIST + statename);
  }

  public getForeignDistrictList(country: string, state: string): Observable<any> {
    const params = { country, state }
    return this.get<any>(ROUTES.DISTRICT_LIST_FOREIGN, { params });
  }
}
